module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.scss
// module id = ./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.scss
// module chunks = 0